<div class="go-back-button">
  <i class="icosun-arrow_left go-back-button_icon-back"
     pTooltip="{{'SI_RETURN' | translate}}"
     tooltipPosition="right"
     (click)="onClickReturn()"
  ></i>
</div>
